import { AppConfig, AppStore, GameLibraryStore, QueueStore } from './AppStore'
import {
  CheckDepositeGameOrderStatusHS,
  CheckOrderStatusHttpHS,
  DWCheckGameOrderStatusHttp,
  DWcheckRechargeOrderStatusHttp,
  DWFinanceDetailHttp,
  DWSendCodeHttp,
  DWVipCheckHttp,
  grantCouponHS,
  JAVAUserExtendInfoHS,
  NewUserGiftHS,
  phpLoginHttp,
  UserInfoHS,
} from 'src/commons/store/UserStore'
import { MtJsWebSDK } from '@mt0926/js-web-sdk'
import { DWBeijingTime } from 'src/commons/store/BasisStore'
import { formatTimeFixedOffset } from 'src/pc/store/UIController'
import { useWaitModData } from '@hhpack/use-cms'
import {
  FormatUserId,
  GetChannel,
  GUID,
  queryUpgradeVipInfo,
  queryLaborDayVipInfo,
  loadRedEnvelopesEntry,
  getForeverVipConfig,
  getFirstPurchaseGiftConfig,
  getNewcomerWelfareConfig,
  recordLoginInfo,
  reportLogin,
  sendMessageToSpeedBall,
  signatureEncode,
} from 'src/commons/utils'
import { AbstractPolling } from 'src/commons/utils/Commons'
import {
  CancelQueueHS,
  DWCheckPromotionOrderHttp,
  getGameLibraryListHS,
  isShowStartGameHelpHS,
} from 'src/commons/store/GameStore'
import { history } from 'src/commons/utils/WebCommons'
import { getPhpToken } from 'src/pc/utils/auth'
import { message } from 'antd'
import { throttle } from 'lodash'
import SocketStore, { CLOUD_EVENTS } from 'src/pc/store/cloudGame/socket'
import { loadWelfareEntry } from 'src/pc/components/receive-welfare-home-entry'
import Cookies from 'js-cookie'
import moment from 'moment'
import SpeedBall from 'src/pc/components/SpeedBall'

/**
 * 验证验证码并发送短信验证码
 */
/*export const SendPhoneCodeAndCheck = async ({ mobile, action, captcha_type, token }: { mobile?: string; action: SendCodeAction; captcha_type: 1 | 2 | 3; token?: string }) => {
  return SendPhoneCode({
    mobile,
    action,
    captcha_type,
    token,
  })
}*/

/**
 * 发送验证码
 * @param {string?} mobile 电话号码
 * @param {number} action 发送类型
 * @param cuid 客户端唯一标识
 * @param captcha_type 验证码类型
 */
export const SendPhoneCodeAndCheck = throttle(
  async ({ mobile, action, captcha_type: captchaType, token }: TSendPhoneCodeAndCheck): Promise<void> => {
    const UserInfo = UserInfoHS.SuccessResult
    const PhoneNo = mobile || (UserInfo ? UserInfo.mobile : undefined)
    if (PhoneNo) {
      const time = new Date().getTime()
      try {
        await DWSendCodeHttp.Execute(
          { mobile: PhoneNo, action, a: GUID(), captcha_type: captchaType, token, channel: GetChannel() },
          {
            headers: {
              timestamp: String(time),
              signature: signatureEncode(PhoneNo + '.' + time),
            },
          },
        )
        CountDownSendPhoneCode()
      } catch (res) {
        message.warn(res.message)
        throw new Error(res.message)
      }
    } else {
      throw new Error('电话号码为必要参数!')
    }
  },
  1000,
  { trailing: false },
) as (params: TSendPhoneCodeAndCheck) => Promise<void>

/**
 * 重置发送手机验证码倒计时
 */
export const resetCountDown = () => {
  clearTimeout(AppConfig.PhoneCaptchaTimer)
  Object.assign(AppStore, {
    PhoneCaptchaLoading: false,
    PhoneCaptchaTime: 120,
    PhoneCaptchaText: '获取验证码',
  })
}

/**
 * 发送手机验证码倒计时
 */
const CountDownSendPhoneCode = () => {
  if (AppStore.PhoneCaptchaTime === 0) {
    resetCountDown()
  } else {
    Object.assign(AppStore, {
      PhoneCaptchaLoading: true,
      PhoneCaptchaTime: AppStore.PhoneCaptchaTime - 1,
      PhoneCaptchaText: `${AppStore.PhoneCaptchaTime}秒后重发`,
    })
    AppConfig.PhoneCaptchaTimer = window.setTimeout(() => {
      CountDownSendPhoneCode()
    }, 1000)
  }
}

/**
 * 获取用户信息
 */
export const getUserInfo = async (token: string): Promise<UserInfo> => {
  try {
    const data = await UserInfoHS.Execute({ token })
    const userId = FormatUserId(data.id)
    try {
      MtJsWebSDK.login(userId)
    } catch (error) {}
    await JAVAUserExtendInfoHS.Execute({ user_id: userId, token })
    const gift = await NewUserGiftHS.Execute({ token })
    /** 存储use_id */
    localStorage.setItem('user_id', data.id + '')
    // 用于卸载页
    if (process.env.BUILD_TYPE.startsWith('dev')) {
      Cookies.set('current_userid', data.id + '', { domain: 'localhost' })
    } else {
      Cookies.set('current_userid', data.id + '', { domain: '99box.com' })
    }
    SocketStore.dispatch(CLOUD_EVENTS.USER_UPDATE, { userId: data.id })
    // const notVip = data && data.vip === 0
    // const notReceived = gift.received === 0
    const hostnames = location.hostname.split('.')
    const domain = `${hostnames[hostnames.length - 2]}.${hostnames[hostnames.length - 1]}`
    Cookies.set('userReportInfo', data, { domain })
    // console.log('user',user,gift)
    // if (notVip || notReceived) {
    // AppStore.welcomeModalVisible = true;
    // }
    return data
  } catch (res) {
    res?.code !== '4010' && window.FuluApp?.JSNotifyCppFunc('need_user_logon')
    throw new Error(res.message)
  }
}

/**
 * 获取用户活动相关的信息
 */
const queryUserActivityInfo = () => {
  queryUpgradeVipInfo()
  queryLaborDayVipInfo()
  loadRedEnvelopesEntry()
  getForeverVipConfig()
  getFirstPurchaseGiftConfig()
  getNewcomerWelfareConfig()
  loadWelfareEntry()
  //静默发券
  grantCouponHS.Execute()
}

/**
 * 登录成功(登录页)
 * @param phpToken 用户凭据
 */
export const successByLoginPage = (phpToken: string) => {
  localStorage.setItem('php-token', phpToken)
  if (window.FuluApp) {
    /*登录成功通知用户登录成功*/
    // window.setTimeout(() => {
    console.log('登陆成功')
    window.FuluApp?.JSNotifyCppFunc('user_logon', phpToken)
    // }, 2000)
    //登录成功，初始化加速球
    AppStore.speedBall = new SpeedBall()
    //同步token到加速球
    sendMessageToSpeedBall('loginSuccess', { token: phpToken })
  }
  getUserInfo(phpToken)
  reportLogin()
  queryUserActivityInfo()
}

/**
 * 登录成功(主程序)
 * @param phpToken 用户凭据
 */
export const loginSuccess = (phpToken: string, isWxToken?: boolean) => {
  console.log('phpToken: ', phpToken, 'isWxToken: ', isWxToken)
  if (isWxToken) {
    window.FuluApp && window.FuluApp?.JSNotifyCppFunc('user_logon', 'WX_ANONYMOUS_USER_TOKEN')
    return
  }
  localStorage.setItem('php-token', phpToken)
  Cookies.remove('STATE')
  if (window.FuluApp) {
    /*登录成功通知用户登录成功*/
    // window.setTimeout(() => {
    window.FuluApp?.JSNotifyCppFunc('user_logon', phpToken)
    // }, 2000)
    /* 登录成功后获取平台安装状态 */
    window.FuluApp.JSNotifyCppFunc('get_gamepaltform_install_status')
    //初始化加速球
    AppStore.speedBall = new SpeedBall()
    //同步token到加速球
    sendMessageToSpeedBall('loginSuccess', { token: phpToken })
  }
  getUserInfo(phpToken)
  queryUserActivityInfo()
}

/**
 * 用户登录
 * @param {string} account 手机号
 * @param {string} password 密码/验证码
 * @param {1|2}type 登录类型
 * @param {boolean}Remember 是否自动登录
 * @param share_code 分享码
 * @param unionid 微信登录 Id
 */
export const doUserLogin = async ({
  account,
  password,
  type,
  share_code: shareCode,
  unionid,
  channel,
}: TDoUserLogin) => {
  const result = await phpLoginHttp.Execute({
    account,
    password,
    type,
    share_code: shareCode,
    unionid,
    channel,
  })
  recordLoginInfo(type, result.is_new)
  loginSuccess(result.token)
  return result
}

export const clearQueueStatus = async () => {
  if (QueueStore.currentQueueInfo && QueueStore.queueStatus !== 'stop') {
    await CancelQueueHS.Execute({ order_no: QueueStore.currentQueueInfo.orderNo })
    QueueStore.currentQueueInfo = null
    QueueStore.queueStatus = 'stop'
  }
}

export const clearGameLibraryStatus = async () => {
  GameLibraryStore.currentGameLibraryGame = null
  GameLibraryStore.currentGameStartInfo = {}
  GameLibraryStore.gameRunStatus = 'stop'
  GameLibraryStore.currentTheRunningGameInfo = null
  GameLibraryStore.currentTheStartingGameInfo = null
  getGameLibraryListHS.SuccessResult = null
  if (window.FuluApp) {
    window.FuluApp.JSNotifyCppFunc('exit_game', 0)
  }
}

/**
 * 检测充值订单支付状态
 */
export const checkRechargeOrderPayStatus = AbstractPolling(async ({ orderNo }: { orderNo: string }) => {
  const data = await DWcheckRechargeOrderStatusHttp.Execute({ orderNo })
  if (data && [1, 2, 3].includes(data)) {
    return data
  }
  throw new Error('未支付')
})

/**
 * 检测订单支付状态
 */
export const checkOrderPayStatus = AbstractPolling(
  async ({ token, order_no: orderNo, order_type: orderType }: TCheckOrderPayStatus) => {
    const data = await DWCheckGameOrderStatusHttp.Execute({ token, order_no: orderNo, order_type: orderType })
    if (data && [1, 2, 3].includes(data.status)) {
      return data
    }
    throw new Error('未支付')
  },
)

/**
 * 检测保证金订单支付状态
 */
export const checkDepositeOrderPayStatus = AbstractPolling(
  async ({ order_no: orderNo, order_type: orderType }: TCheckDepositeOrderPayStatus) => {
    const data = await CheckDepositeGameOrderStatusHS.Execute({ orderNo, orderType })
    if (data && [2, 3].includes(data)) {
      return data
    }
    throw new Error('未支付')
  },
)

/**
 * 检测财务订单支付状态
 * */
export const CheckFinanceOrderPayStatus = AbstractPolling(
  async ({ token, order_no: orderNo, order_type: orderType }: TCheckFinanceOrderPayStatus) => {
    const data = await DWFinanceDetailHttp.Execute({ token, order_no: orderNo, order_type: orderType })
    if (data && [2].includes(data.status)) {
      return true
    }
    throw new Error('未支付')
  },
)

/**
 * 检测特惠游戏订单支付状态
 */
export const CheckPromotionOrderPayStatus = AbstractPolling(
  async ({ order_no: orderNo }: TCheckPromotionOrderPayStatus) => {
    const data = await DWCheckPromotionOrderHttp.Execute({ order_no: orderNo })
    if (data && [1, 2, 3].includes(data.status)) {
      return true
    }
    throw new Error('未支付')
  },
)

/**
 * 检测会员订单状态
 */
export const CheckVipOrderStatus = AbstractPolling(async ({ orderNo }: { orderNo: string }) => {
  const data = await DWVipCheckHttp.Execute(
    { orderNo },
    {
      headers: {
        Authorization: getPhpToken(),
      },
    },
  )
  if (data === 1) {
    return true
  }
  throw new Error('未支付')
})

/**
 * 检测会员订单状态2
 */
export const CheckVipOrderStatus2 = AbstractPolling(async ({ orderNo }: { orderNo: string }) => {
  const data = await CheckOrderStatusHttpHS.Execute(
    { orderNo },
    {
      headers: {
        Authorization: getPhpToken(),
      },
    },
  )
  if (data && [2, 3].includes(data)) {
    return true
  }
  throw new Error('未支付')
})

/** 触发数据埋点 */
/** @TODO */
export function monitoringReport(key: string) {
  const userId = localStorage.getItem('wmUserId')
  if (userId) {
    let script: HTMLScriptElement | null = document.createElement('script')
    script.src = `https://webm.zuhaohao.com/server/upBp?userId=${localStorage.getItem(
      'wmUserId',
    )}&locationPointId=${key}`
    document.body.appendChild(script)
    script.onload = () => {
      document.body.removeChild(script!)
      script = null
    }
  }
}

/**
 * 检测520活动是否截止
 * @param type 活动类型
 */
export const checkActivityTime = async (oldUrl?: string) => {
  const simpleClientActive520Time = await useWaitModData('simpleclient_active520_time')
  if (simpleClientActive520Time && simpleClientActive520Time.length > 0) {
    const endTime = simpleClientActive520Time[0].endTime
    DWBeijingTime.Execute().then(data => {
      const time = moment(endTime).unix() * 1000 - formatTimeFixedOffset(data.time * 1000)
      if (time > 0) {
        return history.push('/activity51')
      } else {
        return history.push(oldUrl ? oldUrl : '/vip')
      }
    })
  } else {
    return history.push(oldUrl ? oldUrl : '/vip')
  }
}

/**
 * PUBG专区tab是否展示
 */
export const isShowPUBGTab = async () => {
  const simpleClientPUBGTab = await useWaitModData<{ isShow: string }>('simpleclient_PUBG_tab')
  AppStore.isShowPUBGTab = simpleClientPUBGTab?.[0] ? simpleClientPUBGTab[0].isShow === '1' : false
}

/**
 * 根据配置和接口判断是否需要在 开始游戏 / 提取CDK 前弹出帮助提示框
 * @param gameId 游戏ID
 * @returns
 */
export const isNeedHelpModal = async (gameId: number): Promise<boolean> => {
  try {
    const ids = AppStore.startHelpConfig?.gameId.split(',') || []
    const finalIndex = ids.findIndex(d => d === `${gameId}`)
    if (AppStore.startHelpConfig && finalIndex > -1) {
      const result = await isShowStartGameHelpHS.Execute({ gameId: ids[finalIndex] })
      return result ? false : true
    } else {
      return true
    }
  } catch (error) {
    return true
  }
}
